import { IS_HEBREW } from './locale';

import { getCustomLogoImageProps } from 'src/utils/get-custom-logo-image-props';

export enum LogoSize {
  BIG = 'big',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export const IMAGE_SIZES_FOR_BIG_LOGO_WITH_SEPARATED_TEXT = {
  height: 80,
  width: 80,
};

export const LOGO_IMAGE_SIZES = {
  en: {
    big: { width: 160, height: 160 },
    medium: { width: 176, height: 40 },
    small: { width: 40, height: 40 },
  },
  he: {
    big: { width: 100, height: 144 },
    medium: { width: 110, height: 44 },
    small: { width: 24, height: 40 },
  },
};
export const LOGO_IMAGE_PROPS = getCustomLogoImageProps();
export const IS_LOGO_TEXT_SEPARATED =
  !IS_HEBREW && !!(window.APP_CEMETERY_LOGO_TITLE || window.APP_CEMETERY_LOGO_SUBTITLE);
export const WITH_CUSTOM_LOGO_HEIGHT =
  !IS_HEBREW && !IS_LOGO_TEXT_SEPARATED && !!LOGO_IMAGE_PROPS?.height;

export const LOGO_SRC = {
  big: `${process.env.PUBLIC_URL}/logos/logo-big-colored.svg`,
  medium: `${process.env.PUBLIC_URL}/logos/logo-medium.svg`,
  small: `${process.env.PUBLIC_URL}/logos/logo-small-colored.svg`,
};
